/* eslint-disable react/jsx-no-bind */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Snackbar from '@material-ui/core/Snackbar';
import { popDashboardMessage } from '@actions/dashboard-actions';

// The dialog snackbar is a Snackbar that will appear within a Dialog component.
const DialogSnackbar = () => {
  const dispatch = useDispatch();
  const { messages } = useSelector(state => state.dashboard.snackbar);
  const isOpen = messages.length !== 0;
  return (
    <Snackbar
      open={isOpen}
      message={messages[0]}
      autoHideDuration={2500}
      onClose={(...args) => dispatch(popDashboardMessage(...args))}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      style={{ bottom: 0 }}
    />
  );
};

export default DialogSnackbar;
